<template>
  <div class="user-dashboard">

    <!-- Profile card -->
    <div class="profile-card">
      <div class="profile-avatar">
        <span>{{ initials }}</span>
      </div>
      <div class="profile-info">
        <h2 class="profile-name">{{ userInfo.user_name || "—" }}</h2>
        <p class="profile-email">
          <v-icon size="14" color="#9e9e9e">mdi-email-outline</v-icon>
          {{ userInfo.user_email || "—" }}
        </p>
        <p class="profile-comment" v-if="userInfo.commentaire">
          {{ userInfo.commentaire }}
        </p>
      </div>
      <div class="profile-actions">
        <v-btn color="#3f51b5" variant="flat" style="color: white;" rounded="lg" size="small"
          @click="showRequestDialog = true">
          <v-icon start size="16">mdi-plus</v-icon>
          Nouvelle demande
        </v-btn>
      </div>
    </div>

    <!-- ═══ Formulaire de demande de congé ═══ -->
    <v-dialog v-model="showRequestDialog" max-width="520" persistent>
      <v-card rounded="xl">
        <!-- Header -->
        <div class="form-dialog-header">
          <div class="form-dialog-icon">
            <v-icon color="#3f51b5" size="22">mdi-calendar-plus</v-icon>
          </div>
          <div>
            <div class="form-dialog-title">Nouvelle demande de congé</div>
            <div class="form-dialog-sub">{{ userInfo.user_name || "" }}</div>
          </div>
          <v-btn icon variant="text" color="#757575" size="small" class="ml-auto" @click="closeForm">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </div>
        <v-card-text class="form-dialog-body">
          <v-form ref="requestForm" v-model="formValid" @submit.prevent="submitRequest">
            <div class="form-label">Type de congé <span class="req">*</span></div>
            <v-select v-model="form.type" :items="congeTypes.filter((val) => val.can_be_create == 1)" hide-details
              item-title="libelle" item-value="id_conge_type" variant="outlined" density="compact" rounded="lg"
              placeholder="Sélectionnez un type" :rules="[v => !!v || 'Champ requis']" class="mb-3">
              <template #item="{ item, props }">
                <v-list-item v-bind="props">
                  <template #prepend>
                    <div class="type-dot" :style="{ background: item.raw.color }"></div>
                  </template>
                </v-list-item>
              </template>
            </v-select>
            <!-- <div v-if="form.type && form.type.length > 0">
              Solde de {{soldeListe.find((val) => val.id_conge_type == form.type)['CONGE_TYPE::libelle']}} : <v-chip
                style="font-weight: bold;" density="compact" class="py-4"
                :color="congeTypes.find((val) => val.id_conge_type == form.type).color"> {{soldeListe.find((val) =>
                  val.id_conge_type == form.type).solde_disponible}} J </v-chip>
            </div> -->
            <!--  <div v-if="form.type && form.type.length > 0" style="color: grey;font-size: 13px;">
              {{congeTypes.find((val) => val.id_conge_type == form.type).description}}
            </div> -->
            <!-- Dates -->
            <v-row class="mt-2">
              <v-col cols="6">
                <div class="form-label">Date de début <span class="req">*</span></div>
                <input type="date" :value="form.dateDebut || ''"
                  @change="form.dateDebut = $event.target.value || null; dateDebutError = ''; updateNbrJours()"
                  class="date-input" :class="{ 'date-input--error': dateDebutError }" />
                <div v-if="dateDebutError" class="date-error-msg">{{ dateDebutError }}</div>
              </v-col>
              <v-col cols="6">
                <div class="form-label">Date de fin <span class="req">*</span></div>
                <input type="date" :value="form.dateFin || ''"
                  @change="form.dateFin = $event.target.value || null; dateFinError = ''; updateNbrJours()"
                  class="date-input" :class="{ 'date-input--error': dateFinError }" />
                <div v-if="dateFinError" class="date-error-msg">{{ dateFinError }}</div>
              </v-col>
            </v-row>

            <!-- Résumé jours ouvrés éditable -->
            <div v-if="form.nbrJours" class="days-summary mt-2">
              <v-icon size="16" color="#3f51b5">mdi-calendar-check-outline</v-icon>
              <input type="number" v-model.number="form.nbrJours" min="0" class="jours-input" />
              <span v-if="form.nbrJours">jour{{ form.nbrJours !== 1 ? 's' : '' }} ouvré{{ form.nbrJours !== 1 ? 's' : ''
                }}</span>
            </div>

            <!-- <div
              v-if="soldeListe && soldeListe.find((val) => val.id_conge_type == form.type) && soldeListe.find((val) => val.id_conge_type == form.type).solde_disponible && form.nbrJours && form.nbrJours > soldeListe.find((val) => val.id_conge_type == form.type).solde_disponible"
              class="mt-2">
              <v-card variant="flat" class="pa-3" style="color:black; border-radius: 10px;font-size: 14px;"
                color="#EF9A9A">
                <v-icon>mdi-alert</v-icon>
                Le nombre de jours de congé demandés est supérieur au solde de congés disponible
                <div style="font-weight: bold;" align="center" class="mb-2">
                  <v-chip variant="flat" style="background-color: white;font-weight: bold;color: black;">
                    {{ form.nbrJours }} J > {{soldeListe.find((val) => val.id_conge_type == form.type).solde_disponible
                    }} J
                  </v-chip>
                </div>
                (ce calcul ne prend pas
                en compte
                les jours fériés)
              </v-card>
            </div> -->

            <!-- Motif -->
            <div class="form-label" style="margin-top: 8px">
              Motif <span class="req">*</span>
            </div>
            <v-textarea v-model="form.motif" variant="outlined" density="compact" rounded="lg" rows="3"
              placeholder="Précisez le motif de votre demande..." :rules="[v => !!v || 'Motif requis']" no-resize />

          </v-form>
        </v-card-text>
        <v-card-actions class="form-dialog-actions">
          <v-btn variant="text" color="#757575" @click="closeForm">Annuler</v-btn>
          <v-spacer />
          <v-btn color="#3f51b5" variant="flat" rounded="lg" style="color: white;" :loading="isSubmitting"
            @click="submitRequest">
            Envoyer la demande
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Contract info grid -->
    <v-row class="info-row">
      <v-col cols="6" sm="4" md="2">
        <div class="info-tile">
          <v-icon size="20" color="#3f51b5">mdi-briefcase-outline</v-icon>
          <span class="info-tile-label">Service</span>
          <span class="info-tile-value">{{ userInfo.service || "—" }}</span>
        </div>
      </v-col>
      <v-col cols="6" sm="4" md="2">
        <div class="info-tile">
          <v-icon size="20" color="#3f51b5">mdi-calendar-star</v-icon>
          <span class="info-tile-label">Date d'embauche</span>
          <span class="info-tile-value">{{ hireDate }}</span>
        </div>
      </v-col>
      <v-col cols="6" sm="4" md="2">
        <div class="info-tile">
          <v-icon size="20" color="#3f51b5">mdi-clock-outline</v-icon>
          <span class="info-tile-label">Heures / semaine</span>
          <span class="info-tile-value">{{ userInfo.heures_hebdo || "—" }}h</span>
        </div>
      </v-col>
      <v-col cols="6" sm="4" md="2">
        <div class="info-tile">
          <v-icon size="20" color="#3f51b5">mdi-calendar-week</v-icon>
          <span class="info-tile-label">Jours travaillés</span>
          <span class="info-tile-value">{{ userInfo.nbr_jours_travaille_par_semaine || "—" }}j / sem.</span>
        </div>
      </v-col>
      <v-col cols="6" sm="4" md="2">
        <div class="info-tile">
          <v-icon size="20" color="#3f51b5">mdi-percent</v-icon>
          <span class="info-tile-label">Taux d'activité</span>
          <span class="info-tile-value">{{ userInfo.taux_activité || "—" }} %</span>
        </div>
      </v-col>
      <v-col cols="6" sm="4" md="2">
        <div class="info-tile" :class="rttEligible ? 'info-tile--yes' : 'info-tile--no'">
          <v-icon size="20" :color="rttEligible ? '#43a047' : '#e53935'">
            {{ rttEligible ? "mdi-check-circle-outline" : "mdi-close-circle-outline" }}
          </v-icon>
          <span class="info-tile-label">Éligibilité RTT</span>
          <span class="info-tile-value" :style="{ color: rttEligible ? '#43a047' : '#e53935' }">
            {{ rttEligible ? "Oui" : "Non" }}
          </span>
        </div>
      </v-col>
    </v-row>

    <!-- Seniority bar -->
    <!-- <div class="seniority-card">
      <div class="seniority-header">
        <v-icon color="#3f51b5" size="18">mdi-medal-outline</v-icon>
        <span class="seniority-title">Jours d'ancienneté</span>
      </div>
      <div class="seniority-body">
        <div class="seniority-stat">
          <span class="seniority-number">{{ userInfo.jour_anciennete_total || 0 }}</span>
          <span class="seniority-label">Total acquis</span>
        </div>
        <div class="seniority-divider"></div>
        <div class="seniority-stat seniority-stat--green">
          <span class="seniority-number">{{ userInfo.jour_anciennete_dispo || 0 }}</span>
          <span class="seniority-label">Disponibles</span>
        </div>
        <div class="seniority-divider"></div>
        <div class="seniority-stat seniority-stat--orange">
          <span class="seniority-number">{{ seniorityUsed }}</span>
          <span class="seniority-label">Utilisés</span>
        </div>
        <div class="seniority-progress-wrap">
          <div class="seniority-progress-track">
            <div class="seniority-progress-fill" :style="{ width: seniorityPercent + '%' }"></div>
          </div>
          <span class="seniority-percent">{{ seniorityPercent }}% utilisé</span>
        </div>
      </div>
    </div> -->

    <div class="section-label mt-4">
      Mon solde <span style="color: grey;font-size: 12px;">(pour l'année en cours)</span>
      <v-btn size="x-small" variant="tonal" :color="hideZeroSolde ? '#3f51b5' : '#9e9e9e'" class="ml-3"
        @click="hideZeroSolde = !hideZeroSolde">
        <v-icon start size="13">{{ hideZeroSolde ? 'mdi-eye' : 'mdi-eye-off' }}</v-icon>
        {{ hideZeroSolde ? 'Tout afficher' : 'Masquer les indisponibles' }}
      </v-btn>
    </div>

    <div v-if="!soldeListe.length" class="solde-empty">
      <v-icon color="#bdbdbd" size="28">mdi-calendar-blank-outline</v-icon>
      <span>Aucun solde disponible</span>
    </div>
    <div v-else class="mb-6">

      <!-- Hero : solde disponible CP -->
      <div class="solde-hero">
        <div class="solde-hero-icon">
          <v-icon color="white" size="28">mdi-wallet-outline</v-icon>
        </div>
        <div class="solde-hero-text">
          <div class="solde-hero-label">Solde disponible</div>
          <div class="solde-hero-value">
            {{ soldeCp.solde_disponible || 0 }}<span class="solde-hero-unit"> jours</span>
          </div>
        </div>
      </div>

      <!-- Blocs N-1 / N uniquement pour CP -->
      <v-row v-if="!hideZeroSolde && soldeCp.id_conge_type" class="mt-3">

        <!-- Bloc Année N-1 -->
        <v-col cols="12" sm="6" class="pt-0">
          <div class="solde-bloc">
            <div class="solde-bloc-header solde-bloc-header--n1">
              <v-icon color="white" size="16">mdi-calendar-arrow-left</v-icon>
              <span>{{ soldeCp.conge_libelle || 'Congés Payés' }}</span>
              <span class="solde-bloc-header-year">N-1</span>
            </div>
            <div class="solde-bloc-rows">
              <div class="solde-bloc-row">
                <div class="solde-bloc-row-left">
                  <div class="solde-bloc-row-icon" style="background:#e5393522;">
                    <v-icon color="#e53935" size="15">mdi-trending-up</v-icon>
                  </div>
                  <span class="solde-bloc-row-label">Acquis</span>
                </div>
                <span class="solde-bloc-row-value" style="color:#e53935;">{{ soldeCp.cp_acquis_n_1 || 0 }}</span>
              </div>
              <div class="solde-bloc-row">
                <div class="solde-bloc-row-left">
                  <div class="solde-bloc-row-icon" style="background:#9c27b022;">
                    <v-icon color="#9c27b0" size="15">mdi-check-circle-outline</v-icon>
                  </div>
                  <span class="solde-bloc-row-label">Pris</span>
                </div>
                <span class="solde-bloc-row-value" style="color:#9c27b0;">{{ soldeCp.cp_pris_n_1 || 0 }}</span>
              </div>
              <div class="solde-bloc-sep"></div>
              <div class="solde-bloc-row solde-bloc-row--total">
                <div class="solde-bloc-row-left">
                  <div class="solde-bloc-row-icon" style="background:#3f51b522;">
                    <v-icon color="#3f51b5" size="15">mdi-piggy-bank-outline</v-icon>
                  </div>
                  <span class="solde-bloc-row-label" style="font-weight:700;color:#1a1a2e;">Solde</span>
                </div>
                <span class="solde-bloc-row-value solde-bloc-row-value--big" style="color:#3f51b5;">{{ soldeCp.cp_solde_n_1 || 0 }}</span>
              </div>
            </div>
          </div>
        </v-col>

        <!-- Bloc Année N -->
        <v-col cols="12" sm="6" class="pt-0">
          <div class="solde-bloc">
            <div class="solde-bloc-header solde-bloc-header--n">
              <v-icon color="white" size="16">mdi-calendar-today</v-icon>
              <span>{{ soldeCp.conge_libelle || 'Congés Payés' }}</span>
              <span class="solde-bloc-header-year">N</span>
            </div>
            <div class="solde-bloc-rows">
              <div class="solde-bloc-row">
                <div class="solde-bloc-row-left">
                  <div class="solde-bloc-row-icon" style="background:#e5393522;">
                    <v-icon color="#e53935" size="15">mdi-trending-up</v-icon>
                  </div>
                  <span class="solde-bloc-row-label">Acquis</span>
                </div>
                <span class="solde-bloc-row-value" style="color:#e53935;">{{ soldeCp.cp_acquis_n || 0 }}</span>
              </div>
              <div class="solde-bloc-row">
                <div class="solde-bloc-row-left">
                  <div class="solde-bloc-row-icon" style="background:#9c27b022;">
                    <v-icon color="#9c27b0" size="15">mdi-check-circle-outline</v-icon>
                  </div>
                  <span class="solde-bloc-row-label">Pris</span>
                </div>
                <span class="solde-bloc-row-value" style="color:#9c27b0;">{{ soldeCp.cp_pris_n || 0 }}</span>
              </div>
              <div class="solde-bloc-sep"></div>
              <div class="solde-bloc-row solde-bloc-row--total">
                <div class="solde-bloc-row-left">
                  <div class="solde-bloc-row-icon" style="background:#3f51b522;">
                    <v-icon color="#3f51b5" size="15">mdi-piggy-bank-outline</v-icon>
                  </div>
                  <span class="solde-bloc-row-label" style="font-weight:700;color:#1a1a2e;">Solde</span>
                </div>
                <span class="solde-bloc-row-value solde-bloc-row-value--big" style="color:#3f51b5;">{{ soldeCp.cp_solde_n || 0 }}</span>
              </div>
            </div>
          </div>
        </v-col>

      </v-row>

      <!-- Cartes autres types (RT, CA, …) -->
      <v-row v-if="!hideZeroSolde && soldeAutres.length" class="mt-3">
        <v-col v-for="s in soldeAutres" :key="s.id_conge_type" cols="12" sm="6" md="4" class="pt-0">
          <div class="solde-type-card">
            <div class="solde-type-header" :style="{ background: getTypeColor(s.id_conge_type) }">
              <v-icon color="white" size="16">mdi-calendar-check-outline</v-icon>
              <span>{{ s.conge_libelle || s.id_conge_type }}</span>
            </div>
            <div class="solde-bloc-rows">
              <div class="solde-bloc-row">
                <div class="solde-bloc-row-left">
                  <div class="solde-bloc-row-icon" style="background:#e5393522;">
                    <v-icon color="#e53935" size="15">mdi-trending-up</v-icon>
                  </div>
                  <span class="solde-bloc-row-label">Initial</span>
                </div>
                <span class="solde-bloc-row-value" style="color:#e53935;">{{ s.solde_initial || 0 }}</span>
              </div>
              <div class="solde-bloc-row">
                <div class="solde-bloc-row-left">
                  <div class="solde-bloc-row-icon" style="background:#9c27b022;">
                    <v-icon color="#9c27b0" size="15">mdi-check-circle-outline</v-icon>
                  </div>
                  <span class="solde-bloc-row-label">Pris</span>
                </div>
                <span class="solde-bloc-row-value" style="color:#9c27b0;">{{ s.solde_pris || 0 }}</span>
              </div>
              <div class="solde-bloc-sep"></div>
              <div class="solde-bloc-row solde-bloc-row--total">
                <div class="solde-bloc-row-left">
                  <div class="solde-bloc-row-icon" style="background:#3f51b522;">
                    <v-icon color="#3f51b5" size="15">mdi-piggy-bank-outline</v-icon>
                  </div>
                  <span class="solde-bloc-row-label" style="font-weight:700;color:#1a1a2e;">Disponible</span>
                </div>
                <span class="solde-bloc-row-value solde-bloc-row-value--big" style="color:#3f51b5;">{{ s.solde_disponible || 0 }}</span>
              </div>
            </div>
          </div>
        </v-col>
      </v-row>

    </div>

    <!-- Leave cards — titre conservé, cartes commentées -->
    <div class="section-label mt-4">
      Mes congés <span style="color: grey;font-size: 12px;">(pour l'année en cours)</span>
    </div>
    <!--
    <div class="section-label">
      Mes congés <span style="color: grey;font-size: 12px;">(pour l'année en cours)</span>
      <v-btn size="x-small" variant="tonal" :color="hideZeroConges ? '#3f51b5' : '#9e9e9e'" class="ml-3"
        @click="hideZeroConges = !hideZeroConges">
        <v-icon start size="13">{{ hideZeroConges ? 'mdi-eye' : 'mdi-eye-off' }}</v-icon>
        {{ hideZeroConges ? 'Tout afficher' : 'Masquer les inactifs' }}
      </v-btn>
    </div>
    <v-row class="">
      <v-col v-for="(conge, i) in congeTypes.filter(c => !hideZeroConges || getJoursPris(c) > 0)" :key="i" cols="12"
        sm="6" md="3">
        <div class="leave-card">
          <div class="card-top-bar" :style="{ background: conge.color }"></div>
          <div class="card-body">
            <h3 class="card-title">{{ conge.libelle }}</h3>
            <p class="card-subtitle">{{ conge.description }}</p>
            <div class="card-stats">
              <div class="stat-row">
                <span class="stat-label">Demandes validées :</span>
                <span class="stat-value">
                  <div v-if="getConge.history.find((val) => val.id_conge_type == conge.id_conge_type)">
                    {{getConge.history.filter((val) => val.statut == 1 && val.id_conge_type ==
                      conge.id_conge_type).length
                    }}
                  </div>
                  <div v-else> 0 </div>
                </span>
              </div>
              <div class="stat-row">
                <span class="stat-label">Jours pris :</span>
                <span class="stat-value">
                  <div v-if="getConge.history.find((val) => val.id_conge_type == conge.id_conge_type)">
                    {{getConge.history.filter((val) => val.statut == 1 && val.id_conge_type ==
                      conge.id_conge_type).reduce((sum, item) => {
                        return sum + Number(item.nbr_days);
                      }, 0)}}
                  </div>
                  <div v-else>
                    0
                  </div>
                </span>
              </div>
            </div>
          </div>
        </div>
      </v-col>
    </v-row>
    -->

    <!-- Demandes en attente -->
    <div class="table-section">
      <div class="table-section-header">
        <div class="table-section-title">
          <v-chip color="#fb8c00" style="font-weight: bold;font-size: 16px;" variant="tonal" class="ml-2">
            <v-icon color="#fb8c00" size="20">mdi-clock-outline</v-icon>
            <span class="pl-1 pr-1">Demandes en attente : </span>
            {{ getConge.pending.length }}
          </v-chip>
        </div>
      </div>
      <v-data-table :headers="pendingHeaders" :items="getConge.pending" :items-per-page="-1" density="compact"
        class="requests-table pb-2" no-data-text="Aucune demande en attente">
        <template #item="{ item }">
          <tr class="pending-row-user" @click="openCancelDialog(item.value)" style="cursor:pointer;"
            title="Cliquez pour annuler cette demande">
            <td>
              <v-chip size="small" style="font-weight: bold;" :color="getTypeColor(item.value.id_conge_type)"
                variant="tonal">
                {{ getTypeName(item.value.id_conge_type) }}
              </v-chip>
            </td>
            <td>{{ formatDate(item.value.debut_timestamp) }}</td>
            <td>{{ formatDate(item.value.fin_timestamp) }}</td>
            <td>{{ item.value.nbr_days || '—' }}</td>
            <td><span class="motif-text">{{ parseMotif(item.value.commentaire) }}</span></td>
            <td>
              <div style="display:flex;align-items:center;gap:8px;">
                <v-chip size="small" style="font-weight: bold;" color="#fb8c00" variant="tonal">
                  <v-icon start size="12">mdi-clock-outline</v-icon>
                  En attente
                </v-chip>
                <v-icon size="16" color="#e53935" title="Annuler">mdi-close-circle-outline</v-icon>
              </div>
            </td>
          </tr>
        </template>
        <template #bottom></template>
      </v-data-table>
    </div>

    <!-- Historique de demandes -->
    <div class="table-section">
      <div class="table-section-header">
        <div class="table-section-title">
          <v-chip color="#3f51b5" style="font-weight: bold;font-size: 16px;" variant="tonal" class="ml-2">
            <v-icon color="#3f51b5" size="18">mdi-history</v-icon>
            <span class="pl-1 pr-1">Historique de demandes : </span>
            <span class=""> {{ getConge.history.length }}</span>
          </v-chip>
          <span class="pt-1" style="color: grey;font-size: 12px;">(les 100 dernières
            demandes)</span>
        </div>
        <v-btn color="#43a047" variant="tonal" size="small" rounded="lg" @click="showExportDialog = true">
          <v-icon start size="16">mdi-microsoft-excel</v-icon>
          Exporter Excel
        </v-btn>
      </div>
      <v-data-table :headers="historyHeaders" :items="getConge.history" :items-per-page="5" density="compact"
        class="requests-table" no-data-text="Aucun historique disponible">
        <template #item="{ item }">
          <tr :class="item.value.statut == 1 ? 'history-row-deletable' : ''"
            :style="item.value.statut == 1 ? 'cursor:pointer;' : ''"
            :title="item.value.statut == 1 ? 'Cliquez pour demander la suppression' : ''"
            @click="item.value.statut == 1 ? openDeleteRequestDialog(item.value) : null">
            <td>
              <v-chip size="small" style="font-weight: bold;" :color="getTypeColor(item.value.id_conge_type)"
                variant="tonal">
                {{ getTypeName(item.value.id_conge_type) }}
              </v-chip>
            </td>
            <td>{{ formatDate(item.value.debut_timestamp) }}</td>
            <td>{{ formatDate(item.value.fin_timestamp) }}</td>
            <td>{{ item.value.nbr_days || '—' }}</td>
            <td><span class="motif-text">{{ parseMotif(item.value.commentaire) }}</span></td>
            <td>
              <v-chip v-if="item.value.statut == 1" style="font-weight: bold;" size="small" color="#43a047"
                variant="tonal">
                <v-icon start size="12">mdi-check-circle-outline</v-icon>
                Validée
                <v-icon end size="13" color="#e53935" class="ml-1">mdi-trash-can-outline</v-icon>
              </v-chip>
              <v-chip v-else-if="item.value.statut == 2" style="font-weight: bold;" size="small" color="#e53935"
                variant="tonal">
                <v-icon start size="12">mdi-close-circle-outline</v-icon>
                Refusée
              </v-chip>
              <v-chip v-else-if="item.value.statut == 3" style="font-weight: bold;" size="small" color="#9e9e9e"
                variant="tonal">
                <v-icon start size="12">mdi-cancel</v-icon>
                Annulée
              </v-chip>
              <v-chip v-else-if="item.value.statut == 4" style="font-weight: bold;" size="small" color="#9c27b0"
                variant="tonal">
                <v-icon start size="12">mdi-trash-can-outline</v-icon>
                Suppression demandée
              </v-chip>
              <v-chip v-else style="font-weight: bold;" size="small" color="#757575" variant="tonal">
                —
              </v-chip>
            </td>
          </tr>
        </template>
      </v-data-table>
    </div>

    <!-- ═══ Dialog annulation demande ═══ -->
    <v-dialog v-model="showCancelDialog" max-width="440" persistent>
      <v-card v-if="requestToCancel" rounded="xl">
        <div class="form-dialog-header">
          <div class="form-dialog-icon" style="background:#ffebee;">
            <v-icon color="#e53935" size="22">mdi-calendar-remove</v-icon>
          </div>
          <div>
            <div class="form-dialog-title">Annuler la demande</div>
            <div class="form-dialog-sub">Cette action est irréversible</div>
          </div>
          <v-btn icon variant="text" color="#757575" size="small" class="ml-auto" @click="showCancelDialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </div>

        <v-card-text class="form-dialog-body">
          <div class="cancel-recap">
            <div class="cancel-recap-row">
              <span class="cancel-recap-label">Type</span>
              <v-chip size="small" style="font-weight:bold;" :color="getTypeColor(requestToCancel.id_conge_type)"
                variant="tonal">
                {{ getTypeName(requestToCancel.id_conge_type) }}
              </v-chip>
            </div>
            <div class="cancel-recap-row">
              <span class="cancel-recap-label">Période</span>
              <span class="cancel-recap-value">
                {{ formatDate(requestToCancel.debut_timestamp) }} → {{ formatDate(requestToCancel.fin_timestamp) }}
              </span>
            </div>
            <div class="cancel-recap-row">
              <span class="cancel-recap-label">Jours</span>
              <span class="cancel-recap-value"><strong>{{ requestToCancel.nbr_days || '—' }}</strong></span>
            </div>
            <div class="cancel-recap-row" v-if="parseMotif(requestToCancel.commentaire) !== '—'">
              <span class="cancel-recap-label">Motif</span>
              <span class="cancel-recap-value">{{ parseMotif(requestToCancel.commentaire) }}</span>
            </div>
          </div>
          <div class="cancel-warning">
            <v-icon size="16" color="#e53935">mdi-alert-outline</v-icon>
            Êtes-vous sûr de vouloir annuler cette demande ?
          </div>
        </v-card-text>

        <v-card-actions class="form-dialog-actions">
          <v-btn variant="text" color="#757575" @click="showCancelDialog = false">Retour</v-btn>
          <v-spacer />
          <v-btn color="#e53935" variant="flat" rounded="lg" style="color:white;" :loading="isCancelling"
            @click="confirmCancel">
            <v-icon start size="16">mdi-close-circle-outline</v-icon>
            Confirmer l'annulation
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- ═══ Dialog demande de suppression ═══ -->
    <v-dialog v-model="showDeleteRequestDialog" max-width="440" persistent>
      <v-card v-if="requestToDelete" rounded="xl">
        <div class="form-dialog-header">
          <div class="form-dialog-icon" style="background:#f3e5f5;">
            <v-icon color="#9c27b0" size="22">mdi-trash-can-outline</v-icon>
          </div>
          <div>
            <div class="form-dialog-title">Demande de suppression</div>
            <div class="form-dialog-sub">Un administrateur traitera votre demande</div>
          </div>
          <v-btn icon variant="text" color="#757575" size="small" class="ml-auto"
            @click="showDeleteRequestDialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </div>

        <v-card-text class="form-dialog-body">
          <div class="cancel-recap">
            <div class="cancel-recap-row">
              <span class="cancel-recap-label">Type</span>
              <v-chip size="small" style="font-weight:bold;" :color="getTypeColor(requestToDelete.id_conge_type)"
                variant="tonal">
                {{ getTypeName(requestToDelete.id_conge_type) }}
              </v-chip>
            </div>
            <div class="cancel-recap-row">
              <span class="cancel-recap-label">Période</span>
              <span class="cancel-recap-value">
                {{ formatDate(requestToDelete.debut_timestamp) }} → {{ formatDate(requestToDelete.fin_timestamp) }}
              </span>
            </div>
            <div class="cancel-recap-row">
              <span class="cancel-recap-label">Jours</span>
              <span class="cancel-recap-value"><strong>{{ requestToDelete.nbr_days || '—' }}</strong></span>
            </div>
          </div>
          <div class="form-label" style="margin-top:4px;">
            Motif de la demande <span class="req">*</span>
          </div>
          <v-textarea v-model="deleteRequestMotif" variant="outlined" density="compact" rounded="lg" rows="3"
            placeholder="Expliquez la raison de votre demande de suppression..." :rules="[v => !!v || 'Motif requis']"
            no-resize />

          <div class="cancel-warning" style="background:#f3e5f5;color:#9c27b0;">
            <v-icon size="16" color="#9c27b0">mdi-information-outline</v-icon>
            La demande sera marquée "Suppression demandée" en attendant la validation d'un administrateur.
          </div>
        </v-card-text>

        <v-card-actions class="form-dialog-actions">
          <v-btn variant="text" color="#757575" @click="showDeleteRequestDialog = false">Retour</v-btn>
          <v-spacer />
          <v-btn color="#9c27b0" variant="flat" rounded="lg" style="color:white;" :loading="isRequestingDelete"
            :disabled="!deleteRequestMotif || !deleteRequestMotif.trim()" @click="confirmDeleteRequest">
            <v-icon start size="16">mdi-trash-can-outline</v-icon>
            Envoyer la demande
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- ═══ Dialog export Excel ═══ -->
    <v-dialog v-model="showExportDialog" max-width="400" persistent>
      <v-card rounded="xl">
        <div class="form-dialog-header">
          <div class="form-dialog-icon" style="background:#e8f5e9;">
            <v-icon color="#43a047" size="22">mdi-microsoft-excel</v-icon>
          </div>
          <div>
            <div class="form-dialog-title">Exporter l'historique</div>
            <div class="form-dialog-sub">Choisissez la période à exporter</div>
          </div>
          <v-btn icon variant="text" color="#757575" size="small" class="ml-auto" @click="showExportDialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </div>

        <v-card-text class="form-dialog-body">
          <div class="form-label mb-3">Période</div>
          <div class="export-period-grid">
            <div class="export-period-chip" :class="{ 'export-period-chip--active': exportPeriod === 'current' }"
              @click="exportPeriod = 'current'">
              <v-icon size="18">mdi-calendar-today</v-icon>
              Mois en cours
            </div>
            <div class="export-period-chip" :class="{ 'export-period-chip--active': exportPeriod === 'previous' }"
              @click="exportPeriod = 'previous'">
              <v-icon size="18">mdi-calendar-arrow-left</v-icon>
              Mois précédent
            </div>
            <div class="export-period-chip" :class="{ 'export-period-chip--active': exportPeriod === 'all' }"
              @click="exportPeriod = 'all'">
              <v-icon size="18">mdi-calendar-blank-multiple</v-icon>
              Tout
            </div>
            <div class="export-period-chip" :class="{ 'export-period-chip--active': exportPeriod === 'custom' }"
              @click="exportPeriod = 'custom'">
              <v-icon size="18">mdi-calendar-range</v-icon>
              Personnalisé
            </div>
          </div>

          <v-row v-if="exportPeriod === 'custom'" class="mt-3">
            <v-col cols="6">
              <div class="form-label">Du</div>
              <input type="date" v-model="exportDateFrom" class="date-input" />
            </v-col>
            <v-col cols="6">
              <div class="form-label">Au</div>
              <input type="date" v-model="exportDateTo" class="date-input" />
            </v-col>
          </v-row>

          <div class="export-count-info mt-3">
            <v-icon size="15" color="#3f51b5">mdi-information-outline</v-icon>
            <span>{{ filteredHistoryForExport.length }} demande{{ filteredHistoryForExport.length !== 1 ? 's' : '' }} à
              exporter</span>
          </div>
        </v-card-text>

        <v-card-actions class="form-dialog-actions">
          <v-btn variant="text" color="#757575" @click="showExportDialog = false">Annuler</v-btn>
          <v-spacer />
          <v-btn color="#43a047" variant="flat" rounded="lg" style="color:white;"
            :disabled="filteredHistoryForExport.length === 0" @click="doExportExcel">
            <v-icon start size="16">mdi-microsoft-excel</v-icon>
            Exporter
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

  </div>
  <v-snackbar v-model="snackbar.value" :color="snackbar.color">
    <div align="center">
      {{ snackbar.msg }}
    </div>
  </v-snackbar>
</template>

<script>
import moment from 'moment';
import engine from "@/core/index";
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';

export default {
  name: "HomeUser",
  props: {
    userInfo: { type: Object, default: () => ({}) },
    congeTypes: { type: Array, default: () => [] },
  },
  data() {
    return {
      soldeDisplay: [
        ['cp_acquis_n', 'cp_acquis_n_1', 'red', 'Acquis', 'mdi-trending-up'],
        ['cp_solde_n', 'cp_solde_n', 'blue', 'Solde', 'mdi-piggy-bank-outline'],
        ['cp_pris_n', 'cp_pris_n_1', 'green', 'CP', 'mdi-check-circle-outline'],
        ['cp_reserves_n', 'cp_reserves_n_1', 'purple', 'Réservé', 'mdi-lock-clock'],
      ],
      snackbar: {},
      soldeListe: [],
      congeListe: [],
      showRequestDialog: false,
      hideZeroSolde: true,
      hideZeroConges: true,
      dateDebutError: '',
      dateFinError: '',
      formValid: false,
      isSubmitting: false,
      showCancelDialog: false,
      requestToCancel: null,
      isCancelling: false,
      showDeleteRequestDialog: false,
      requestToDelete: null,
      isRequestingDelete: false,
      deleteRequestMotif: '',
      showExportDialog: false,
      exportPeriod: 'all',
      exportDateFrom: null,
      exportDateTo: null,
      form: {
        type: null,
        dateDebut: null,
        dateFin: null,
        nbrJours: null,
        motif: "",
      },
      pendingHeaders: [
        { title: 'Type', key: 'id_conge_type', sortable: true },
        { title: 'Date début', key: 'debut_timestamp', sortable: true },
        { title: 'Date fin', key: 'fin_timestamp', sortable: true },
        { title: 'Jours', key: 'nbr_days', sortable: true },
        { title: 'Motif', key: 'commentaire', sortable: false },
        { title: 'Statut', key: 'statut', sortable: true },
      ],
      historyHeaders: [
        { title: 'Type', key: 'id_conge_type', sortable: true },
        { title: 'Date début', key: 'debut_timestamp', sortable: true },
        { title: 'Date fin', key: 'fin_timestamp', sortable: true },
        { title: 'Jours', key: 'nbr_days', sortable: true },
        { title: 'Motif', key: 'commentaire', sortable: false },
        { title: 'Statut', key: 'statut', sortable: true },
      ],
      leaveTypes: [
        {
          key: "cp",
          title: "Congés Payés",
          subtitle: "25 jours ouvrés par an",
          color: "#3f51b5",
          validated: 0,
          daysTaken: 0,
        },
        {
          key: "rtt",
          title: "RTT",
          subtitle: "Réduction du temps de travail",
          color: "#43a047",
          validated: 0,
          daysTaken: 0,
        },
        {
          key: "exceptional",
          title: "Congés Exceptionnels",
          subtitle: "Selon la règlementation (motif requis)",
          color: "#fb8c00",
          validated: 0,
          daysTaken: 0,
        },
        {
          key: "unpaid",
          title: "Congés Sans Solde",
          subtitle: "Sur autorisation préalable",
          color: "#757575",
          validated: 0,
          daysTaken: 0,
        },
      ],
    };
  },
  mounted() {
    this.update_user_data()
  },
  computed: {
    getConge() {
      let conge = {
        pending: [],
        history: [],
        all: []
      }

      if (this.congeListe && this.congeListe.length > 0) {
        for (let i = 0; i < this.congeListe.length; i++) {
          if (this.congeListe[i].statut == 0) {
            conge.pending.push(this.congeListe[i])
          } else if (this.congeListe[i].statut > 0) {
            conge.history.push(this.congeListe[i])
          }
          conge.all.push(this.congeListe[i])
        }
      }

      return conge
    },
    initials() {
      const name = this.userInfo?.user_name || "";
      return name
        .split(" ")
        .map((w) => w[0])
        .join("")
        .toUpperCase()
        .slice(0, 2) || "?";
    },
    hireDate() {
      const ts = parseInt(this.userInfo?.date_embauche_timestamp);
      if (!ts) return "—";
      return new Date(ts * 1000).toLocaleDateString("fr-FR", {
        day: "2-digit",
        month: "long",
        year: "numeric",
      });
    },
    rttEligible() {
      return this.userInfo?.eligibilite_RTT == 1;
    },
    seniorityUsed() {
      const total = parseInt(this.userInfo?.jour_anciennete_total) || 0;
      const dispo = parseInt(this.userInfo?.jour_anciennete_dispo) || 0;
      return Math.max(0, total - dispo);
    },
    seniorityPercent() {
      const total = parseInt(this.userInfo?.jour_anciennete_total) || 0;
      if (total === 0) return 0;
      return Math.round((this.seniorityUsed / total) * 100);
    },
    soldeCp() {
      if (!Array.isArray(this.soldeListe)) return {};
      return this.soldeListe.find(s => s.id_conge_type === 'CP') || {};
    },
    soldeAutres() {
      if (!Array.isArray(this.soldeListe)) return [];
      return this.soldeListe.filter(s => s.id_conge_type !== 'CP');
    },
    filteredHistoryForExport() {
      return this.filterByPeriod(this.getConge.history);
    },
    leaveTypeOptions() {
      return this.congeTypes.map(t => ({
        label: t.libelle,
        value: t.id_conge_type,
        description: t.description,
        color: t.color,
        libelle: t.libelle,
      }));
    },
    selectedTypeIsExceptional() {
      if (!this.form.type) return false;
      const found = this.leaveTypeOptions.find(t => t.value === this.form.type);
      return found ? found.libelle.toLowerCase().includes('exception') : false;
    },
    workingDays() {
      const { dateDebut, dateFin } = this.form;
      if (!dateDebut || !dateFin || dateFin < dateDebut) return 0;
      let count = 0;
      const cur = new Date(dateDebut);
      const end = new Date(dateFin);
      while (cur <= end) {
        const d = cur.getDay();
        if (d !== 0 && d !== 6) count++;
        cur.setDate(cur.getDate() + 1);
      }
      return count;
    },
  },
  methods: {
    soldeColorHex(colorName) {
      const colorMap = {
        red: '#e53935', blue: '#3f51b5', green: '#43a047',
        orange: '#fb8c00', yellow: '#f9a825', purple: '#9c27b0',
        gray: '#757575', grey: '#757575', pink: '#e91e63',
        teal: '#00838f', cyan: '#00acc1', indigo: '#3f51b5',
      };
      return colorMap[colorName] || colorName || '#3f51b5';
    },
    update_user_data() {
      this.update_user_solde()
      this.update_user_conges()
    },
    update_user_solde() {
      let that = this
      console.log("update_user_solde");

      engine.get_solde_by_user_id(this.userInfo.user_id, function (data) {
        console.log("data", data);

        if (data.code == 0) {
          that.soldeListe = data.data.data.data.map((val) => val.fieldData)
          console.log("soldeListe", that.soldeListe);

        }
      })
    },
    update_user_conges() {
      let that = this
      engine.get_conge_by_user_id(this.userInfo.user_id, function (data) {
        if (data.code == 0) {
          that.congeListe = data.data.data.data.map((val) => ({
            ...val.fieldData,
            _recordId: val.recordId,
          }))
        }
      })
    },
    getJoursPris(conge) {
      return this.getConge.history
        .filter(v => v.statut == 1 && v.id_conge_type == conge.id_conge_type)
        .reduce((sum, item) => sum + Number(item.nbr_days), 0);
    },
    getSoldeColor(solde) {
      const colorMap = {
        red: '#e53935', blue: '#3f51b5', green: '#43a047',
        orange: '#fb8c00', yellow: '#f9a825', purple: '#9c27b0',
        gray: '#757575', grey: '#757575', pink: '#e91e63',
        teal: '#00838f', cyan: '#00acc1', indigo: '#3f51b5',
      };
      const found = this.congeTypes.find(t => t.id_conge_type === solde.id_conge_type);
      if (!found) return '#3f51b5';
      return colorMap[found.color] || found.color || '#3f51b5';
    },
    updateNbrJours() {
      this.$nextTick(() => {
        this.form.nbrJours = this.workingDays || null;
      });
    },
    pad(n) {
      return String(n).padStart(2, "0");
    },
    formatDate(ts) {
      if (!ts) return "—";
      return new Date(parseInt(ts) * 1).toLocaleDateString("fr-FR", {
        day: "2-digit", month: "2-digit", year: "numeric",
      });
    },
    getTypeName(id) {
      const found = this.congeTypes.find(t => t.id_conge_type === id);
      return found ? found.libelle : id || "—";
    },
    getTypeColor(id) {
      const colorMap = {
        red: '#e53935', blue: '#3f51b5', green: '#43a047',
        orange: '#fb8c00', yellow: '#f9a825', purple: '#9c27b0',
        gray: '#757575', grey: '#757575', pink: '#e91e63',
        teal: '#00838f', cyan: '#00acc1', indigo: '#3f51b5',
      };
      const found = this.congeTypes.find(t => t.id_conge_type === id);
      if (!found) return '#757575';
      return colorMap[found.color] || found.color || '#757575';
    },
    parseMotif(commentaire) {
      if (!commentaire) return "—";
      try {
        const parsed = JSON.parse(commentaire);
        if (Array.isArray(parsed) && parsed[0]?.user) return parsed[0].user || "—";
      } catch {
        return commentaire;
      }
      return commentaire;
    },
    openDeleteRequestDialog(item) {
      this.requestToDelete = item;
      this.deleteRequestMotif = '';
      this.showDeleteRequestDialog = true;
    },
    confirmDeleteRequest() {
      if (!this.requestToDelete?.id_demande || !this.deleteRequestMotif.trim()) return;
      this.isRequestingDelete = true;
      let that = this;
      engine.update_conge_statut(this.requestToDelete.id_demande, 4, function () {
        that.isRequestingDelete = false;
        that.showDeleteRequestDialog = false;
        that.requestToDelete = null;
        that.deleteRequestMotif = '';
        that.update_user_conges();
      });
    },
    openCancelDialog(item) {
      this.requestToCancel = item;
      this.showCancelDialog = true;
    },
    confirmCancel() {
      if (!this.requestToCancel?.id_demande) return;
      this.isCancelling = true;
      let that = this;

      console.log("requestToCancel", this.requestToCancel);

      engine.update_conge_statut(this.requestToCancel.id_demande, 3, function () {
        that.isCancelling = false;
        that.showCancelDialog = false;
        that.requestToCancel = null;
        that.update_user_conges();
      });
    },
    filterByPeriod(items) {
      const now = new Date();
      let startDate = null;
      let endDate = null;
      if (this.exportPeriod === 'current') {
        startDate = new Date(now.getFullYear(), now.getMonth(), 1);
        endDate = new Date(now.getFullYear(), now.getMonth() + 1, 0, 23, 59, 59);
      } else if (this.exportPeriod === 'previous') {
        startDate = new Date(now.getFullYear(), now.getMonth() - 1, 1);
        endDate = new Date(now.getFullYear(), now.getMonth(), 0, 23, 59, 59);
      } else if (this.exportPeriod === 'custom') {
        startDate = this.exportDateFrom ? new Date(this.exportDateFrom) : null;
        endDate = this.exportDateTo ? new Date(this.exportDateTo + 'T23:59:59') : null;
      } else {
        return items; // 'all'
      }
      return items.filter(item => {
        const d = new Date(parseInt(item.debut_timestamp));
        if (startDate && d < startDate) return false;
        if (endDate && d > endDate) return false;
        return true;
      });
    },
    doExportExcel() {
      const statusLabel = (statut) => {
        if (statut == 1) return 'Validée';
        if (statut == 2) return 'Refusée';
        return 'En attente';
      };

      const rows = this.filteredHistoryForExport.map((item) => ({
        'Type': this.getTypeName(item.id_conge_type),
        'Date début': this.formatDate(item.debut_timestamp),
        'Date fin': this.formatDate(item.fin_timestamp),
        'Jours': item.nbr_days || '—',
        'Motif': this.parseMotif(item.commentaire),
        'Statut': statusLabel(item.statut),
      }));

      const ws = XLSX.utils.json_to_sheet(rows);
      ws['!cols'] = [{ wch: 22 }, { wch: 14 }, { wch: 14 }, { wch: 8 }, { wch: 36 }, { wch: 12 }];

      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, 'Historique');

      const periodLabel = this.exportPeriod === 'current' ? moment().format('YYYY-MM')
        : this.exportPeriod === 'previous' ? moment().subtract(1, 'month').format('YYYY-MM')
          : this.exportPeriod === 'custom' ? `${this.exportDateFrom || ''}_${this.exportDateTo || ''}`
            : 'complet';
      const wbout = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
      const fileName = `historique_conges_${this.userInfo.user_name || 'export'}_${periodLabel}.xlsx`;
      saveAs(new Blob([wbout], { type: 'application/octet-stream' }), fileName);
      this.showExportDialog = false;
    },
    onCardClick(leave) {
      this.$emit("open-details", leave);
    },
    closeForm() {
      this.showRequestDialog = false;
      this.$nextTick(() => {
        this.form = { type: null, dateDebut: null, dateFin: null, nbrJours: null, motif: "" };
        this.dateDebutError = '';
        this.dateFinError = '';
        this.$refs.requestForm?.reset();
      });
    },
    async submitRequest() {

      // engine.run_conge_function('demande.accepter', { "id_demande": selectedRequest.id_demande }, function (data) {
      //   console.log("run_conge_function", data);
      //   that.isUpdating = false;
      //   that.showValidationModal = false;
      // })

      let that = this

      this.dateDebutError = '';
      this.dateFinError = '';
      if (!this.form.dateDebut) this.dateDebutError = 'Champ requis';
      if (!this.form.dateFin) this.dateFinError = 'Champ requis';
      else if (this.form.dateDebut && this.form.dateFin < this.form.dateDebut)
        this.dateFinError = 'Doit être après le début';
      if (this.dateDebutError || this.dateFinError) return;

      const { valid } = await this.$refs.requestForm.validate();
      if (!valid) return;
      this.isSubmitting = true;
      let payload = {
        statut: 0,
        id_conge_type: this.form.type,
        user_id: this.userInfo.user_id,
        debut_timestamp: parseInt(moment(this.form.dateDebut).format('x')),
        fin_timestamp: parseInt(moment(this.form.dateFin).format('x')),
        commentaire: JSON.stringify([{ 'user': this.form.motif }]),
        nbr_days: this.form.nbrJours ?? this.workingDays,
      };

      console.log("payload", payload);
      engine.run_conge_function('nouvelle.demande', payload, function (data) {
        console.log("run_conge_function", data);
        let scriptResult = JSON.parse(data.data.data.scriptResult)

        console.log("scriptResult", scriptResult);

        if (scriptResult.valide == true) {
          that.snackbar = {
            color: 'green',
            value: true,
            msg: 'Demande de congé en cours de traitement ' + (scriptResult.commentaire && scriptResult.commentaire.length > 0 ? scriptResult.commentaire : '')
          }
          // engine.create_demande_conge(payload, function () {
          that.update_user_data()
          // })
          that.showRequestDialog = false
          that.form = {}
        } else {
          that.snackbar = {
            color: 'red',
            value: true,
            msg: 'Demande de congé invalide ' + (scriptResult.commentaire && scriptResult.commentaire.length > 0 ? scriptResult.commentaire : '')
          }
        }
        that.isSubmitting = false;
        that.isUpdating = false;
      })

      // engine.create_demande_conge(payload, function () {
      //   that.update_user_conges()
      // })

      // this.isSubmitting = false;
      // this.closeForm();
    },
  },
};
</script>

<style scoped>
.user-dashboard {
  padding: 32px 40px;
  background: #f0f2f5;
  min-height: calc(100vh - 64px);
}

/* ── Profile card ── */
.profile-card {
  display: flex;
  align-items: center;
  gap: 20px;
  background: white;
  border-radius: 16px;
  padding: 22px 28px;
  box-shadow: 0 2px 16px rgba(63, 81, 181, 0.07);
  margin-bottom: 20px;
  flex-wrap: wrap;
}

.profile-avatar {
  width: 56px;
  height: 56px;
  border-radius: 50%;
  background: linear-gradient(135deg, #3f51b5, #283593);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  font-weight: 700;
  color: white;
  flex-shrink: 0;
}

.profile-info {
  flex: 1;
  min-width: 0;
}

.profile-name {
  font-size: 20px;
  font-weight: 700;
  color: #1a1a2e;
  margin: 0 0 4px 0;
  text-transform: capitalize;
}

.profile-email {
  display: flex;
  align-items: center;
  gap: 5px;
  font-size: 13px;
  color: #757575;
  margin: 0 0 4px 0;
}

.profile-comment {
  font-size: 13px;
  color: #9e9e9e;
  margin: 0;
  font-style: italic;
}

.profile-actions {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 8px;
  margin-left: auto;
  flex-shrink: 0;
}

.pending-badge {
  display: flex;
  align-items: center;
  gap: 5px;
  background: #fff8e1;
  border: 1px solid #ffca28;
  border-radius: 20px;
  padding: 5px 12px;
  font-size: 12px;
  color: #f57c00;
  font-weight: 600;
  white-space: nowrap;
}

/* ── Formulaire dialog ── */
.form-dialog-header {
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 20px 20px 16px;
  border-bottom: 1px solid #f0f0f0;
}

.form-dialog-icon {
  width: 42px;
  height: 42px;
  border-radius: 12px;
  background: #e8eaf6;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.form-dialog-title {
  font-size: 16px;
  font-weight: 700;
  color: #1a1a2e;
}

.form-dialog-sub {
  font-size: 12px;
  color: #9e9e9e;
  margin-top: 2px;
}

.form-dialog-body {
  padding: 20px 20px 8px !important;
}

.form-dialog-actions {
  padding: 12px 20px 18px !important;
}

.form-label {
  font-size: 12px;
  font-weight: 600;
  color: #424242;
  margin-bottom: 6px;
  text-transform: uppercase;
  letter-spacing: 0.3px;
}

.req {
  color: #e53935;
}

.optional {
  color: #9e9e9e;
  font-weight: 400;
  text-transform: none;
}

.jours-input {
  width: 48px;
  text-align: center;
  border: none;
  border-bottom: 2px solid #3f51b5;
  background: transparent;
  font-size: 14px;
  font-weight: 700;
  color: #3f51b5;
  padding: 0 2px;
  outline: none;
  font-family: inherit;
}

.jours-input::-webkit-inner-spin-button,
.jours-input::-webkit-outer-spin-button {
  opacity: 1;
}

.date-input {
  width: 100%;
  height: 40px;
  border: 1px solid rgba(0, 0, 0, 0.38);
  border-radius: 8px;
  padding: 0 12px;
  font-size: 14px;
  color: #424242;
  background: white;
  cursor: pointer;
  box-sizing: border-box;
  transition: border-color 0.15s, border-width 0.15s;
  font-family: inherit;
}

.date-input:focus {
  outline: none;
  border: 2px solid #3f51b5;
}

.date-input:hover:not(:focus) {
  border-color: rgba(0, 0, 0, 0.87);
}

.date-input--error {
  border-color: #e53935 !important;
}

.date-error-msg {
  font-size: 12px;
  color: #e53935;
  margin-top: 4px;
  padding-left: 4px;
}

.type-dot {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  margin-right: 8px;
}

.days-summary {
  display: flex;
  align-items: center;
  gap: 6px;
  background: #e8eaf6;
  border-radius: 8px;
  padding: 8px 14px;
  font-size: 13px;
  color: #3f51b5;
  margin-bottom: 12px;
}

/* ── Info tiles ── */
.info-row {
  margin-bottom: 4px;
}

.info-tile {
  background: white;
  border-radius: 12px;
  padding: 14px 16px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;
  height: 100%;
  border-left: 3px solid #e8eaf6;
  transition: box-shadow 0.15s;
}

.info-tile:hover {
  box-shadow: 0 4px 14px rgba(63, 81, 181, 0.1);
}

.info-tile--yes {
  border-left-color: #43a047;
}

.info-tile--no {
  border-left-color: #e53935;
}

.info-tile-label {
  font-size: 11px;
  font-weight: 600;
  color: #9e9e9e;
  text-transform: uppercase;
  letter-spacing: 0.4px;
}

.info-tile-value {
  font-size: 15px;
  font-weight: 700;
  color: #1a1a2e;
}

/* ── Seniority ── */
.seniority-card {
  background: white;
  border-radius: 14px;
  padding: 18px 24px;
  box-shadow: 0 2px 12px rgba(63, 81, 181, 0.06);
  margin-bottom: 28px;
  margin-top: 8px;
}

.seniority-header {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 16px;
}

.seniority-title {
  font-size: 14px;
  font-weight: 700;
  color: #1a1a2e;
}

.seniority-body {
  display: flex;
  align-items: center;
  gap: 20px;
  flex-wrap: wrap;
}

.seniority-stat {
  display: flex;
  flex-direction: column;
  align-items: center;
  min-width: 60px;
}

.seniority-number {
  font-size: 28px;
  font-weight: 800;
  color: #3f51b5;
  line-height: 1;
}

.seniority-stat--green .seniority-number {
  color: #43a047;
}

.seniority-stat--orange .seniority-number {
  color: #fb8c00;
}

.seniority-label {
  font-size: 11px;
  color: #9e9e9e;
  font-weight: 500;
  margin-top: 2px;
}

.seniority-divider {
  width: 1px;
  height: 36px;
  background: #f0f0f0;
}

.seniority-progress-wrap {
  flex: 1;
  min-width: 160px;
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.seniority-progress-track {
  height: 8px;
  background: #f0f2f5;
  border-radius: 999px;
  overflow: hidden;
}

.seniority-progress-fill {
  height: 100%;
  background: linear-gradient(90deg, #3f51b5, #fb8c00);
  border-radius: 999px;
  transition: width 0.4s ease;
}

.seniority-percent {
  font-size: 11px;
  color: #9e9e9e;
  font-weight: 500;
  text-align: right;
}

/* ── Solde empty ── */
.solde-empty {
  display: flex;
  align-items: center;
  gap: 8px;
  color: #bdbdbd;
  font-size: 14px;
  margin-bottom: 16px;
}

/* ── Solde hero ── */
.solde-hero {
  display: flex;
  align-items: center;
  gap: 20px;
  background: linear-gradient(135deg, #2e7d32, #43a047);
  border-radius: 16px;
  padding: 22px 28px;
  margin-top: 12px;
  box-shadow: 0 4px 20px rgba(67, 160, 71, 0.28);
}

.solde-hero-icon {
  width: 56px;
  height: 56px;
  border-radius: 14px;
  background: rgba(255, 255, 255, 0.2);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.solde-hero-text {
  display: flex;
  flex-direction: column;
}

.solde-hero-label {
  font-size: 12px;
  font-weight: 600;
  color: rgba(255, 255, 255, 0.75);
  text-transform: uppercase;
  letter-spacing: 0.6px;
  margin-bottom: 2px;
}

.solde-hero-value {
  font-size: 38px;
  font-weight: 800;
  color: white;
  line-height: 1.1;
}

.solde-hero-unit {
  font-size: 16px;
  font-weight: 500;
  opacity: 0.8;
}

/* ── Solde blocs N / N-1 ── */
.solde-bloc {
  background: white;
  border-radius: 14px;
  overflow: hidden;
  box-shadow: 0 2px 12px rgba(63, 81, 181, 0.07);
  height: 100%;
  box-sizing: border-box;
}

.solde-bloc-header {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px 18px;
  font-size: 13px;
  font-weight: 700;
  letter-spacing: 0.4px;
  color: white;
  text-transform: uppercase;
}

.solde-bloc-header--n {
  background: linear-gradient(135deg, #3f51b5, #283593);
}

.solde-bloc-header--n1 {
  background: linear-gradient(135deg, #607d8b, #455a64);
}

.solde-bloc-header-year {
  margin-left: auto;
  background: rgba(255, 255, 255, 0.2);
  border-radius: 6px;
  padding: 2px 8px;
  font-size: 11px;
  font-weight: 800;
  letter-spacing: 0.5px;
}

.solde-bloc-rows {
  padding: 14px 18px 16px;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.solde-bloc-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.solde-bloc-row-left {
  display: flex;
  align-items: center;
  gap: 10px;
}

.solde-bloc-row-icon {
  width: 30px;
  height: 30px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.solde-bloc-row-label {
  font-size: 13px;
  color: #616161;
  font-weight: 500;
}

.solde-bloc-row-value {
  font-size: 18px;
  font-weight: 700;
}

.solde-bloc-sep {
  height: 1px;
  background: #f0f0f0;
  margin: 2px 0;
}

.solde-bloc-row--total .solde-bloc-row-label {
  font-size: 14px;
}

.solde-bloc-row-value--big {
  font-size: 26px;
  font-weight: 800;
}

/* ── Cartes autres types ── */
.solde-type-card {
  background: white;
  border-radius: 14px;
  overflow: hidden;
  box-shadow: 0 2px 12px rgba(63, 81, 181, 0.07);
  height: 100%;
  box-sizing: border-box;
}

.solde-type-header {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px 18px;
  font-size: 13px;
  font-weight: 700;
  letter-spacing: 0.4px;
  color: white;
  text-transform: uppercase;
}

.section-label {
  font-size: 15px;
  font-weight: 700;
  color: #1a1a2e;
  margin-bottom: 14px;
}


.leave-card {
  background: white;
  border-radius: 16px;
  box-shadow: 0 2px 16px rgba(63, 81, 181, 0.07);
  overflow: hidden;
  cursor: pointer;
  transition: transform 0.18s, box-shadow 0.18s;
  height: 100%;
}

.leave-card:hover {
  transform: translateY(-3px);
  box-shadow: 0 6px 24px rgba(63, 81, 181, 0.14);
}

.card-top-bar {
  height: 4px;
  width: 100%;
}

.card-body {
  padding: 18px 20px 16px;
}

.card-title {
  font-size: 15px;
  font-weight: 700;
  color: #1a1a2e;
  margin: 0 0 4px 0;
}

.card-subtitle {
  font-size: 11px;
  color: #9e9e9e;
  margin: 0 0 16px 0;
  line-height: 1.5;
}

.card-stats {
  margin-bottom: 16px;
}

.stat-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 6px;
}

.stat-label {
  font-size: 12px;
  font-weight: 600;
  color: #424242;
}

.stat-value {
  font-size: 18px;
  font-weight: 700;
  color: #1a1a2e;
}

.card-btn-row {
  display: flex;
  justify-content: center;
}

.details-btn {
  min-width: 90px;
}

/* ── Tables sections ── */
.table-section {
  background: white;
  border-radius: 16px;
  box-shadow: 0 2px 16px rgba(63, 81, 181, 0.07);
  margin-top: 24px;
  overflow: hidden;
}

.table-section-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 18px 20px 12px;
  border-bottom: 1px solid #f0f2f5;
}

.table-section-title {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 15px;
  font-weight: 700;
  color: #1a1a2e;
}

.requests-table {
  border-radius: 0 !important;
}

.motif-text {
  font-size: 12px;
  color: #616161;
  max-width: 180px;
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

/* ── Pending rows (annulable) ── */
.pending-row-user:hover td {
  background: #fff3e0;
}

/* ── History rows (suppression demandable) ── */
.history-row-deletable:hover td {
  background: #fce4ec;
}

/* ── Cancel dialog ── */
.cancel-recap {
  background: #fafafa;
  border-radius: 10px;
  padding: 14px 16px;
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-bottom: 14px;
  border: 1px solid #f0f0f0;
}

.cancel-recap-row {
  display: flex;
  align-items: center;
  gap: 12px;
}

.cancel-recap-label {
  font-size: 12px;
  font-weight: 600;
  color: #9e9e9e;
  text-transform: uppercase;
  letter-spacing: 0.4px;
  min-width: 64px;
}

.cancel-recap-value {
  font-size: 14px;
  color: #424242;
}

.cancel-warning {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 13px;
  color: #e53935;
  background: #ffebee;
  border-radius: 8px;
  padding: 10px 14px;
  font-weight: 500;
}

/* ── Export period dialog ── */
.export-period-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 10px;
}

.export-period-chip {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px 14px;
  border-radius: 10px;
  border: 2px solid #e8eaf6;
  font-size: 13px;
  font-weight: 600;
  color: #424242;
  cursor: pointer;
  transition: all 0.15s;
  background: #fafafa;
}

.export-period-chip:hover {
  border-color: #3f51b5;
  background: #f3f4fb;
  color: #3f51b5;
}

.export-period-chip--active {
  border-color: #3f51b5;
  background: #e8eaf6;
  color: #3f51b5;
}

.export-count-info {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 12px;
  color: #757575;
  background: #f3f4fb;
  border-radius: 8px;
  padding: 8px 12px;
}

/* ── Responsive ── */
@media (max-width: 600px) {
  .user-dashboard {
    padding: 16px 14px;
  }

  .profile-card {
    padding: 16px 18px;
  }

  .seniority-body {
    gap: 12px;
  }
}
</style>
